import IconComponent from "@CubeComponents/icons";
import UserNameTagComponent from "../../../cubeComponent/html/UserNameTagComponent";
import type { ChatConversation } from "../api/portalChat.api";

/**
 * The conversation glyph used by list rows, the thread header and the forward picker: the other
 * person's avatar for a direct chat, a people glyph in a brand-blue circle for a group, the Spaces
 * glyph on the deeper blue for a project (space) chat.
 */
export function ConversationAvatar({
  conversation,
  size = "row",
}: {
  readonly conversation: ChatConversation;
  readonly size?: "row" | "header" | "small";
}) {
  const dimension = size === "row" ? "h-10 w-10" : size === "header" ? "h-9 w-9" : "h-8 w-8";
  const glyph = size === "small" ? "0.9rem" : "1.1rem";
  if (conversation.type === "direct" && conversation.otherUser) {
    return <UserNameTagComponent showAvatarOnly id={String(conversation.otherUser._id)} size="XS" isCircle />;
  }
  return (
    <span
      className={`flex ${dimension} shrink-0 items-center justify-center rounded-full ${
        conversation.type === "space" ? "bg-[#2F7AA0]" : "bg-[#4794BA]"
      }`}
    >
      {/* The house icons are dark monochrome <img>s — the filter renders them white on the disc. */}
      <IconComponent
        name={conversation.type === "space" ? "Grouping" : "usersIcon"}
        width={glyph}
        height={glyph}
        className="brightness-0 invert"
      />
    </span>
  );
}
